import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    contentDialog: {
      ...CommonFonts.grayFont16,
    },
    titleDialog: {
      ...CommonFonts.grayFont18,
      fontWeight: '500',
    },
    boxRedirect: {
      textAlign: 'center',
    },
    link: {
      textDecoration: 'none',
    },
    linkText: {
      ...CommonFonts.blueFont16,
    },
  })
);

export default useStyles;
